require('../css/about.scss');

$(() => {
    function updateSvgs() {
        const firstItem = $('#details .col > div:first-child');
        firstItem.find('svg').each((index, element) => {
            const firstHeight = firstItem.find('.outer.image').height();
            $(element).children('line.horizontal')
                .attr('x1', 16)
                .attr('x2', $(element).parent().width() - 16)
                .attr('y1', firstHeight / 2)
                .attr('y2', firstHeight / 2);
            $(element).children('line.vertical')
                .attr('x1', $(element).parent().width() / 2)
                .attr('x2', $(element).parent().width() / 2)
                .attr('y1', firstHeight / 2)
                .attr('y2', $(element).parent().height());
        });

        $('#details .col > div:not(:first-child):not(:last-child)').each((outerIndex, element) => {
            $(element).find('svg').each((innerIndex, svg) => {
                const height = $(element).find('.outer').height();
                $(svg).children('line')
                    .attr('x1', $(svg).parent().width() / 2)
                    .attr('x2', $(svg).parent().width() / 2)
                    .attr('y1', 0)
                    .attr('y2', $(svg).parent().height());
                $(svg).children('circle')
                    .attr('cx', $(svg).parent().width() / 2)
                    .attr('cy', height / 2);
            });
        });

        const lastItem = $('#details .col > div:last-child');
        lastItem.find('svg').each((index, element) => {
            const lastHeight = lastItem.find('.outer.image').height();
            $(element).children('line.horizontal')
                .attr('x1', 16)
                .attr('x2', $(element).parent().width() - 16)
                .attr('y1', lastHeight / 2)
                .attr('y2', lastHeight / 2);
            $(element).children('line.vertical')
                .attr('x1', $(element).parent().width() / 2)
                .attr('x2', $(element).parent().width() / 2)
                .attr('y1', 0)
                .attr('y2', lastHeight / 2);
        });
    }

    updateSvgs();
    const elems = document.getElementsByTagName('svg');
    for (const elem of elems) {
        elem.classList.toggle('d-none');
    }

    $(window).resize(() => {
        updateSvgs();
    });
});
